import Sensor from "./Sensors.js";

// Handles accelerometer and gyroscope
export class Motion extends Sensor {
    constructor() {
        super();
        this._boundHandler = this._handleMotion.bind(this);
        this._data = { accelerometer: null, gyroscope: null };
    }

    get accelerometer() { return this._data?.accelerometer ?? null; }
    get gyroscope() { return this._data?.gyroscope ?? null; }

    async start() {
        if (this._listening) return true;

        try {
            const granted = await this.requestPermission(
                typeof DeviceMotionEvent !== `undefined` ? DeviceMotionEvent : null
            );
            if (!granted) return false;

            window.addEventListener(`devicemotion`, this._boundHandler, { passive: true });
            this._listening = true;
            return true;
        } catch (e) {
            console.error(`[Motion] Start error:`, e);
            return false;
        }
    }

    stop() {
        if (!this._listening) return;
        window.removeEventListener(`devicemotion`, this._boundHandler);
        this._listening = false;
    }

    _handleMotion(event) {
        const now = performance.now();

        const acc = event.accelerationIncludingGravity;
        const rot = event.rotationRate;

        // ---- Accelerometer (match obfuscated behavior) ----
        if (acc && acc.x !== null) {
            const x = acc.x || 0;
            const y = acc.y || 0;
            const z = acc.z || 0;

            this._data.accelerometer = {
                x,
                y,
                z,
                magnitude: Math.sqrt(x * x + y * y + z * z),
                timestamp: now
            };
        } else {
            // If accel is invalid, don’t emit an "accelerometer" event
            this._data.accelerometer = null;
        }

        // ---- Gyroscope (unchanged) ----
        if (rot) {
            this._data.gyroscope = {
                alpha: rot.alpha,
                beta: rot.beta,
                gamma: rot.gamma,
                timestamp: now
            };
        } else {
            this._data.gyroscope = null;
        }

        // Emit combined snapshot
        this.dispatchEvent(new CustomEvent(`motion`, { detail: this._data }));

        // Emit individual channels only when valid
        if (this._data.accelerometer) {
            this.dispatchEvent(new CustomEvent(`accelerometer`, { detail: this._data.accelerometer }));
        }
        if (this._data.gyroscope) {
            this.dispatchEvent(new CustomEvent(`gyroscope`, { detail: this._data.gyroscope }));
        }
    }
}

export default Motion;
